import styled from 'styled-components';

export const SignUpDiv = styled.div`
`;

export const Container = styled.div`
    background: #fff;
    margin: 0 auto;
    max-width: 410px;
    padding: 2.5rem 2rem;


    @media(max-height: 800px){
        margin: 2rem auto;
    }

    @media(max-height: 700px) and (max-width: 860px) {
        padding-top: 0;
    }
`;

export const Heading = styled.header`
    margin: 0;

    h1 {
        margin: 0 0 0.5rem 0;
    }

    span {
        display: block;
        font-size: 1.8rem;
        opacity: 0.5;
    }
`;

export const Label = styled.label`
    background: #fff;
    color: #bbb;
    font-size: 1.4rem;
    padding: 0.5rem;
    position: relative;
    top: 0.9rem;
    left: 1.4rem;
`;

export const Input = styled.input`
    border: 2px solid #eee;
    border-radius: 8px;
    display: block;
    padding: 1.4rem 1.2rem;
    font-size: 1.6rem;
    font-weight: bold;
    margin: 0 0 2rem 0;
    width: 100%;

    &:focus {
        border-color: #FA578E;
        outline: none;
    }

`;

export const Select = styled.select`
    display: block;
    margin: 0 0 2rem 0;
    width: 100%;
`;

export const Option = styled.option`
    width: 100%;
    padding: 1rem
`;

export const SubmitButton = styled.button`
    border: none;
    border-radius: 8px;
    background: linear-gradient(to right, #FA578E, #FDA88E);
    color: #fff;
    cursor: pointer;
    display: block;
    font-size: 1.6rem;
    padding: 1.4rem;
    transition: all 200ms ease;
    margin-top: 3rem;
    width: 100%;

    &:hover {
        background: linear-gradient(to right, #fb89af, #fdb9a4);
    }

    &:focus {
        outline: none;
    }

    &:active {
        transform: scale(0.9);
    }
`;